<button mat-button class="ca-button ca-button-xs mb-2" (click)="drawer.open()">
    <ca-icon icon="settings" class="ca-icon-s"></ca-icon> <span>{{ 'RBR.BUTTON.SET_DEFAULTS' | translate }}</span>
</button>

<ca-drawer #drawer overriddenWidth="664px" [bodyBordered]="true" [bodyNoPaddings]="true">
    <h2 drawer-header class="ca-headline-2 ca-bold m-0">{{ headerText() | translate }}</h2>
    <div drawer-body class="pt-6">
        @if (isConfirmPending()) {
            <div class="ca-fullscreen-spinner-container">
                <ca-spinner
                    [diameter]="80"
                    [text]="'LOADER.PROCESSING_REQUEST.TITLE' | translate"
                    [subtext]="'LOADER.PROCESSING_REQUEST.DESCRIPTION' | translate"
                ></ca-spinner>
            </div>
        }
        <ca-question-flow
            (contextChange)="onContextChange($event)"
            [initialContextModel]="questionFlowContext()"
            [hideActionButtons]="true"
            [hideTimeline]="true"
            [configuration]="qfDefaultValues"
        ></ca-question-flow>
    </div>
    <button drawer-footer mat-stroked-button class="ca-button ca-button-m" (click)="onCancel()">
        <span>{{ 'CA.BUTTON.CANCEL' | translate }}</span>
    </button>
    <button drawer-footer mat-flat-button class="ca-button ca-button-m" (click)="onConfirm()">
        <span>{{ 'CA.BUTTON.CONFIRM' | translate }}</span>
    </button>
</ca-drawer>
